const HIDDEN_CLASS = 'is-hidden';

/**
 * 右側固定の SNS リンクを、ページ最下部（フッター）に来たらフェードアウトする。
 */
export function initFixedSns() {
  const sns = document.querySelector('.js-fixed-sns');
  const footer = document.querySelector('.l-footer');
  if (!sns || !footer || !('IntersectionObserver' in window)) {
    return;
  }

  const observer = new IntersectionObserver(([entry]) => {
    sns.classList.toggle(HIDDEN_CLASS, entry.isIntersecting);
  });

  observer.observe(footer);
}
